(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__sectionRowCarouselInitV1) return;
  window.__sectionRowCarouselInitV1 = true;

  const ATTR = 'data-section-row-carousel';
  const READY = 'data-row-carousel-initialized';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function scrollBehaviorMode() {
    return prefersReducedMotion() ? 'instant' : 'smooth';
  }

  function slideWidth(el) {
    const w = el.clientWidth;
    return w > 0 ? w : 1;
  }

  function lastSlideIndex(el) {
    const w = slideWidth(el);
    const maxScroll = Math.max(0, el.scrollWidth - w);
    return Math.max(0, Math.round(maxScroll / w));
  }

  function activeIndex(el) {
    const w = slideWidth(el);
    const last = lastSlideIndex(el);
    const raw = Math.round(el.scrollLeft / w);
    return Math.max(0, Math.min(raw, last));
  }

  /**
   * @param {HTMLButtonElement[]} dots
   * @param {number} index
   */
  function setDotsState(dots, index) {
    dots.forEach((dot, i) => {
      const on = i === index;
      dot.classList.toggle('is-active', on);
      dot.setAttribute('aria-current', on ? 'true' : 'false');
    });
  }

  /**
   * @param {HTMLElement} el
   * @param {number} index
   */
  function scrollToIndex(el, index) {
    const w = slideWidth(el);
    const last = lastSlideIndex(el);
    const clamped = Math.max(0, Math.min(index, last));
    el.scrollTo({ left: clamped * w, behavior: scrollBehaviorMode() });
  }

  /**
   * @param {HTMLElement} el
   */
  function initRowCarousel(el) {
    if (!(el instanceof HTMLElement)) return;
    if (el.hasAttribute(READY)) return;
    el.setAttribute(READY, '');

    const shell = el.closest('.section-row-carousel-shell');
    const dotsWrap = shell?.querySelector('[data-section-row-carousel-dots]');
    const dots = dotsWrap ? Array.from(dotsWrap.querySelectorAll('[data-carousel-dot]')) : [];

    let scrollRaf = 0;
    const syncDots = () => {
      if (!dots.length) return;
      cancelAnimationFrame(scrollRaf);
      scrollRaf = requestAnimationFrame(() => {
        setDotsState(dots, activeIndex(el));
      });
    };

    el.addEventListener('scroll', syncDots, { passive: true });
    window.addEventListener('resize', syncDots, { passive: true });

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const idx = Number.parseInt(String(dot.getAttribute('data-carousel-dot') || '0'), 10);
        scrollToIndex(el, Number.isNaN(idx) ? 0 : idx);
      });
    });

    el.addEventListener('keydown', (event) => {
      const cur = activeIndex(el);
      const last = lastSlideIndex(el);
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        scrollToIndex(el, cur - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        scrollToIndex(el, Math.min(last, cur + 1));
      }
    });

    syncDots();
  }

  /**
   * @param {ParentNode} root
   */
  function scan(root) {
    root.querySelectorAll(`[${ATTR}]`).forEach(initRowCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan(document));
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    const target = event.target;
    if (target instanceof Element) scan(target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
